import { defineStore } from 'pinia'
import { ref } from 'vue'
import { fetchTrip360 } from '@/backend/trip360Api'

// Глобальное состояние 360-окна рейса: любой компонент может вызвать
// openTrip360(key) — попап смонтирован в App.vue и живёт поверх роутов.
export const useTrip360Store = defineStore('trip360', () => {
	const isOpen = ref(false)
	const key = ref(null)
	const trip = ref(null)
	const loading = ref(false)
	const error = ref(null)

	// null | 'compact' | 'full' — ручной оверрайд режима окна.
	const modeOverride = ref(null)

	// Начальная вкладка при открытии (null — дефолтная «Сводка»).
	const initialTab = ref(null)

	let requestSeq = 0

	async function openTrip360(tripKey, options = {}) {
		const normalized = tripKey == null ? '' : String(tripKey).trim()
		if (!normalized) return
		const seq = ++requestSeq
		key.value = normalized
		initialTab.value = options.tab || null
		isOpen.value = true
		loading.value = true
		error.value = null
		try {
			const data = await fetchTrip360(normalized)
			if (seq !== requestSeq) return
			trip.value = data
		} catch (e) {
			if (seq !== requestSeq) return
			trip.value = null
			const detail = e?.response?.data?.detail
			error.value = detail || 'Не удалось загрузить данные рейса'
		} finally {
			if (seq === requestSeq) loading.value = false
		}
	}

	function close() {
		requestSeq++
		isOpen.value = false
		key.value = null
		trip.value = null
		error.value = null
		modeOverride.value = null
		initialTab.value = null
	}

	function setModeOverride(mode) {
		modeOverride.value = mode
	}

	return {
		isOpen,
		key,
		trip,
		loading,
		error,
		modeOverride,
		initialTab,
		openTrip360,
		close,
		setModeOverride,
	}
})
